import { render, staticRenderFns } from "./UserfulFilesIntroSection.vue?vue&type=template&id=c5aa8234"
import script from "./UserfulFilesIntroSection.vue?vue&type=script&lang=ts"
export * from "./UserfulFilesIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./UserfulFilesIntroSection.vue?vue&type=style&index=0&id=c5aa8234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports